import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import {
  ADD_SCHOR_VERTICAL,
  EDIT_SCHOR_VERTICAL,
  VIEW_SCHOR_VERTICAL,
  LIST_SCHOR_VERTICAL,
  DELETE_SCHOR_VERTICAL,
  ADD_SCHOR_VERTICAL_TEXT,
  EDIT_SCHOR_VERTICAL_TEXT,
  VIEW_SCHOR_VERTICAL_TEXT,
  LIST_SCHOR_VERTICAL_TEXT,
  DELETE_SCHOR_VERTICAL_TEXT
} from "./actionTypes"
import { schorVerticalSuccess, schorVerticalError } from "./actions"


import {
  onAddSchorVertical,
  onEditSchorVertical,
  onViewSchorVertical,
  onListSchorVertical,
  onDeleteSchorVertical,
  onAddSchorVerticalText,
  onEditSchorVerticalText,
  onListSchorVerticalText,
  onViewSchorVerticalText,
  onDeleteSchorVerticalText
} from "helpers/backend_api_helper";

// add schor vertical
function* addSchorVertical({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddSchorVertical, data);
    yield put(schorVerticalSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(schorVerticalError(error?.response?.data?.message || "Server Error"));
  }
}

// edit schor vertical
function* editSchorVertical({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditSchorVertical, data, id);
    yield put(schorVerticalSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(schorVerticalError(error?.response?.data?.message || "Server Error"));
  }
}

// list schor vertical
function* listSchorVertical({ payload: { data, callback } }) {
  try {
    const response = yield call(onListSchorVertical, data);
    yield put(schorVerticalSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(schorVerticalError(error?.response?.data?.message || "Server Error"));
  }
}

// view schor vertical
function* viewSchorVertical({ payload: { data, history } }) {
  try {
    const response = yield call(onViewSchorVertical, data);
    yield put(schorVerticalSuccess(response));

  } catch (error) {
    yield put(schorVerticalError(error?.response?.data?.message || "Server Error"));
  }
}

// delete schor vertical
function* deleteSchorVertical({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteSchorVertical, data);
    yield put(schorVerticalSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(schorVerticalError(error?.response?.data?.message || "Server Error"));
  }
}


// text
// add schor vertical
function* addAspirationText({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddSchorVerticalText, data);
    yield put(schorVerticalSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(schorVerticalError(error?.response?.data?.message || "Server Error"));
  }
}

// edit schor vertical
function* editAspirationText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditSchorVerticalText, data, id);
    yield put(schorVerticalSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(schorVerticalError(error?.response?.data?.message || "Server Error"));
  }
}

// list schor vertical
function* listAspirationText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onListSchorVerticalText, data, id);
    yield put(schorVerticalSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(schorVerticalError(error?.response?.data?.message || "Server Error"));
  }
}

// view schor vertical
function* viewAspirationText({ payload: { data, history } }) {
  try {
    const response = yield call(onViewSchorVerticalText, data);
    yield put(schorVerticalSuccess(response));

  } catch (error) {
    yield put(schorVerticalError(error?.response?.data?.message || "Server Error"));
  }
}

// delete schor vertical
function* deleteAspirationText({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteSchorVerticalText, data);
    yield put(schorVerticalSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(schorVerticalError(error?.response?.data?.message || "Server Error"));
  }
}



function* SchorVerticalSaga() {
  yield takeEvery(ADD_SCHOR_VERTICAL, addSchorVertical);
  yield takeEvery(EDIT_SCHOR_VERTICAL, editSchorVertical);
  yield takeEvery(LIST_SCHOR_VERTICAL, listSchorVertical);
  yield takeEvery(VIEW_SCHOR_VERTICAL, viewSchorVertical);
  yield takeEvery(DELETE_SCHOR_VERTICAL, deleteSchorVertical);

  // text
  yield takeEvery(ADD_SCHOR_VERTICAL_TEXT, addAspirationText);
  yield takeEvery(EDIT_SCHOR_VERTICAL_TEXT, editAspirationText);
  yield takeEvery(LIST_SCHOR_VERTICAL_TEXT, listAspirationText);
  yield takeEvery(VIEW_SCHOR_VERTICAL_TEXT, viewAspirationText);
  yield takeEvery(DELETE_SCHOR_VERTICAL_TEXT, deleteAspirationText);
}

export default SchorVerticalSaga;

